export const environment = {
  apiUrl: 'https://kiarafy-engine-mw32k.ondigitalocean.app',
};
